import RouterLink from "../../Link/RouterLink";
import {
  homepage_presta_formation,
  homepage_presta_supervision,
  homepage_presta_dae,
} from "../../../Imgs/images";
import { useEffect } from "react";
import hasTouch from "../../../utils/CheckTouch";
import Scroller from "../../../utils/Scroller";
import DotsObservers from "../../../utils/DotsObservers";

let scroller: Scroller;
let dotsObservers: DotsObservers;

function Services() {
  useEffect(() => {
    if (!hasTouch()) {
      scroller = new Scroller("team-scroller");
      scroller.attachWindowResize();
    }

    dotsObservers = new DotsObservers(
      ".sp-scroller-panel",
      ".sp-scroller-dot",
      "panel",
      "active",
      55,
    );

    dotsObservers.createObservers();
    dotsObservers.startObservers();

    return () => {
      if (scroller) scroller.detachEvents();
      if (dotsObservers) {
        dotsObservers.stopObservers();
        dotsObservers.destroyObservers();
      }
    };
  });

  return (
    <section className="hp-services">
      <h2 className="sp-section-title hp-services-title">Nos services</h2>
      <div className="sp-scroller">
        <div className="sp-scroller-container" id="team-scroller">
          <div
            className="sp-scroller-panel hp-services-scroller-panel"
            data-panel={0}
            id="panel-0"
          >
            <picture className="sp-panel-img">
              <source srcSet={homepage_presta_formation} />
              <img src={homepage_presta_formation} alt="" />
            </picture>
            <div className="sp-panel-content">
              <h3 className="sp-panel-title">Formations</h3>
              <p className="sp-panel-description">
                Des outils pédagogiques sur mesure adaptés à votre organisation,
                en présentiel dans nos locaux où directement sur vos sites.
              </p>
              <RouterLink
                to="/formation"
                className="sp-panel-button sp-panel-button-blue"
              >
                En savoir plus
              </RouterLink>
            </div>
          </div>
          <div
            className="sp-scroller-panel hp-services-scroller-panel"
            data-panel={1}
            id="panel-1"
          >
            <picture className="sp-panel-img">
              <source srcSet={homepage_presta_supervision} />
              <img src={homepage_presta_supervision} alt="" />
            </picture>
            <div className="sp-panel-content">
              <h3 className="sp-panel-title">
                Conseil et Assistance Technique
              </h3>
              <p className="sp-panel-description">
                Intervention au sein des chantiers et ateliers selon les
                contraintes de production.
              </p>
              <RouterLink
                to="/supervision"
                className="sp-panel-button sp-panel-btn-disabled"
              >
                Bientôt disponible
              </RouterLink>
            </div>
          </div>
          <div
            className="sp-scroller-panel hp-services-scroller-panel"
            data-panel={2}
            id="panel-2"
          >
            <picture className="sp-panel-img">
              <source srcSet={homepage_presta_dae} />
              <img src={homepage_presta_dae} alt="" />
            </picture>
            <div className="sp-panel-content">
              <h3 className="sp-panel-title">DAE / Défibrillateur</h3>
              <p className="sp-panel-description">
                Vente et maintenance de matériel de secours pour les secteurs de
                la Seine-Maritime et de l'Eure.
              </p>
              <RouterLink
                to="/service-entreprises"
                className="sp-panel-button sp-panel-button-orange sp-panel-btn-disabled"
              >
                Bientôt disponible
              </RouterLink>
            </div>
          </div>
        </div>
        <div className="sp-scroller-dots sp-scroller-dots-hide">
          <div className="sp-scroller-dot"></div>
          <div className="sp-scroller-dot"></div>
          <div className="sp-scroller-dot"></div>
        </div>
      </div>
      <RouterLink to="/contact" className="sp-button">
        <span className="sp-button-text">Nous contacter</span>
        <div className="sp-button-arrow"></div>
      </RouterLink>
    </section>
  );
}

export default Services;
